/**
 * Appendix Placeholder Slide
 */

import React from 'react';
import styled from 'styled-components';
import { colors } from '@config/colors';
import { typography } from '@config/typography';
import { spacing, borderRadius } from '@config/spacing';
import {
  DataSlide,
} from '@components/press/pitch-deck/slide-primitives';

const WipBanner = styled.div`
  padding: ${spacing.sm} ${spacing.md};
  background: ${colors.accent.coral.exxtraLight};
  border: 1px solid ${colors.accent.coral.dark};
  border-radius: ${borderRadius.md};
  font-family: ${typography.fontFamily.heading};
  font-size: clamp(${typography.fontSize.xs}, 1.2vw, ${typography.fontSize.sm});
  font-weight: ${typography.fontWeight.semibold};
  color: ${colors.accent.coral.exxtraDark};
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 1px;
`;

export const AppendixOverviewSlide: React.FC = () => (
  <DataSlide title="Appendix" subtitle="">
    <WipBanner>Work in Progress</WipBanner>
  </DataSlide>
);
